import { types } from "mobx-state-tree";
import { ValidationMesssageModel } from "../ValidationMesssage";

export const DecimalNumberProperties = types.model({
  precision: types.maybeNull(types.number),
  length: types.maybeNull(types.number),
});

export const NumberValidatorModel = types.model({}).views(() => {
  return {
    numberTooLargeMessage(maximumNumberValue: number) {
      return ValidationMesssageModel.create({
        message: { mainKey: "general.validation.number-length-long" },
        context: { maximumNumberValue },
      });
    },

    numberTooLarge(maxValue: number, fieldValueAsString: string) {
      return Number(fieldValueAsString) > maxValue;
    },

    numberTooLong(length: number, integerPart: string, fractionalPart?: string) {
      return integerPart.length + (fractionalPart?.length ?? 0) > length;
    },

    numberTooShort(length: number, integerPart: string, fractionalPart?: string) {
      return integerPart.length + (fractionalPart?.length ?? 0) < length;
    },

    isANumber(value: any) {
      return RegExp(/^-?[0-9,.,]+$/).test(value);
    },
  };
});
